import {PostExamsRebook} from 'domain/usecases';
import {RemotePostExamsRebook} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookedFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePostExamsRebook = (): PostExamsRebook =>
	new RemotePostExamsRebook(
		makeBFFApiUrl(BookedFlowEndPoints.examsRebooking),
		makeAuthorizeHttpClientDecorator(),
	);
